import React from 'react';
const FullScreenLoadingComponent = () => {
  return (
    <div className=" chameleon-loader-background">
      <div className="chameleon-loader">
        <div className="chameleon-loader-dots-white g2w-chameleon-loader" />
      </div>
    </div>
  );
};

export default FullScreenLoadingComponent;



// WEBPACK FOOTER //
// ./src/Components/Loaders/FullScreenLoadingComponent.js